import { createStore } from 'vuex'

export default createStore({
  state: {
    access_token: ''
  },
  mutations: {
    setToken(state, token = ''){
      state.access_token = token;
    },
    delToken(state){
      state.access_token = ''
    }
  },
  actions: {
  },
  modules: {
  }
})
